import { render, staticRenderFns } from "./PaymentFlow.vue?vue&type=template&id=2a4cba0a&"
import script from "./PaymentFlow.vue?vue&type=script&lang=js&"
export * from "./PaymentFlow.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFlow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports